module.exports = __webpack_public_path__ + "static/img/iconfont.97b86931.svg";